const reviewEntry = document.querySelector('[data-ac-owned-review-entry]');
if (reviewEntry) {
  const destination = reviewEntry.dataset.reviewUrl || '/pages/leave-a-review';
  const connect = () => {
    document.querySelectorAll('a.jdgm-write-rev-link').forEach((link) => {
      link.dataset.acOwnedReviewLink = 'true';
      if (link.getAttribute('href') !== destination) link.setAttribute('href', destination);
      if (link.textContent !== 'Leave a review') link.textContent = 'Leave a review';
      if (link.hasAttribute('aria-expanded')) link.removeAttribute('aria-expanded');
    });
  };
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a.jdgm-write-rev-link') : null;
    if (!link) return;
    event.stopImmediatePropagation();
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    window.location.assign(destination);
  }, true);
  connect();
  const observer = new MutationObserver(connect);
  const observe = () => observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'aria-expanded']});
  observe();
  window.addEventListener('pageshow', () => { connect(); observe(); });
  window.addEventListener('pagehide', () => observer.disconnect(), {once: true});
}
